import { render, staticRenderFns } from "./PaymentOrdererInfo.vue?vue&type=template&id=03d30494&scoped=true&"
import script from "./PaymentOrdererInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentOrdererInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrdererInfo.vue?vue&type=style&index=0&id=03d30494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d30494",
  null
  
)

export default component.exports